module.exports = "<div class=\"header\">\n  <h1><a href=\".\"><</a> Point path</h1>\n</div>\n<iframe src=\"apps/point_path/index.html\"></iframe>\n"


//////////////////
// WEBPACK FOOTER
// /home/manu/ArtCode/artCode/artCode/src/app/pages/point_path/point_path.component.html
// module id = ../../../../../src/app/pages/point_path/point_path.component.html
// module chunks = main